var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrm-base-layout"},[_c('layout',[_c('div',{staticClass:"app-view-box",attrs:{"id":"subapp-viewport"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }